import { FlexiSlider } from "appworks/graphics/elements/flexi-slider";
import { FlexiText } from "appworks/graphics/elements/flexi-text";
import { Services } from "appworks/services/services";
import { ValueList } from "appworks/utils/value-list";
import { gameiomModel } from "gameiom/model/gameiom-model";
import { UIDenomDisplayType } from "gameiom/wrapper/wrapper-data";
import { slotModel } from "slotworks/model/slot-model";
import { SlotBetService } from "slotworks/services/bet/slot-bet-service";
import { AgsAbstractSliderControl } from "./ags-abstract-slider-control";

export class AgsCreditSizeLimitSliderControl extends AgsAbstractSliderControl {
    constructor(slider: FlexiSlider, label: FlexiText, minLabel?: FlexiText, maxLabel?: FlexiText) {
        super(slider, label);

        const useDenomDisplay: boolean = gameiomModel.denomDisplay === UIDenomDisplayType.denom;
        const displayWholeNumber: boolean = gameiomModel.shouldDisplayCurrencyAsWholeNumber();
        if (!useDenomDisplay || displayWholeNumber) {
            this.slider.formatFunction = (index: number): string => {
                return this.sliderValues.values[index].toString();
            };
        }

        this.slider.setLabels(minLabel, maxLabel);
        this.updateData();
    }

    public setEnabled(enabled: boolean): void {
        const { freeBet } = slotModel.read().bet;
        super.setEnabled(!freeBet && enabled);
    }

    // This is a stupid workaround for typescript's bullshit instance variable inheritance rules.
    protected shouldShowZeroValueOption() {
        return false;
    }

    protected getModelData(): ValueList<number> {
        return slotModel.read().bet.creditSizes;
    }

    protected saveModelData(selectedValue: number) {
        Services.get(SlotBetService).setCreditSize(selectedValue);
    }
}
